import React from 'react';
// import RunService from '../../../services/api/Run';
import RunService from 'services/api/Run';
import { HotTable } from '@handsontable/react';
import { registerAllModules } from 'handsontable/registry';
import ScaleLoader from 'react-spinners/ScaleLoader';
import Select from 'react-select';

import '../../assets/css/catalog.css';
import CsvLoad from './CsvLoad';
import LoadingOverlay from 'react-loading-overlay';
import { HandsonTableKey } from '../../settings/shared/constants';
import 'handsontable/dist/handsontable.min.css';
import { Tooltip, Typography } from '@material-ui/core';
import StorageService from '../../services/api/Storage';
import page404 from 'assets/img/404.png';
import { downloadData } from 'services/downloadData';
import { Row, Col } from 'reactstrap';
import { HyperFormula } from 'hyperformula';
import axios from 'axios'
import { CSVToJSONs} from "settings/shared/commonMethod";

// register Handsontable's modules
registerAllModules();

const delimiteroptions = [
  { label: 'Comma Seperated Value (,)', value: ',' },
  { label: 'Pipe Seperated Value (|)', value: '|' },
];

class ViewCsv extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      myContent: '',
      chartHeader: [],
      delimiter: ',',
      errorFile: '',
      fileName: '',
      fileType: '',
      totalPages: 0,
      delimiter: ',',
      activePage: 1,
      totalRecords: 0,
      loading: false,
      storageId: '',
      rootFolder: '',
      // wholeGraphData: [],
      DownloadUrl: '',
      showNoDataFound: true,
    };
    this.hotformula = {
      formulas: {
        engine: HyperFormula,
      }
    }

  }

  componentDidMount() {
    let ext = 'csv';
    if (typeof this.props.versionName === "object") {
      this.downloadObjectUrl(this.props.fileName);
    } else {
      this.downloadVersionUrl(this.props.fileName, this.props.versionName);
    }
    this.setState({ fileType: ext });
  }

  downloadObjectUrl = (fileName) =>{
    StorageService.downloadObjectUrl(
      fileName,
      this.state.storageId,
      this.state.rootFolder
    )
      .then((response) => {
        if(response !== null && response !== undefined && response.hasOwnProperty("download_url")){
          this.renderText(response.download_url);
          this.setState({ DownloadUrl: response.download_url });
        }
      })
      .catch((error) => {
        this.state.fileType = 'png';
        this.state.myContent = page404;
        this.state.fileName = 'File Not Found!!!';
        this.setState({ loading: false });
      });
  }

  downloadVersionUrl = (fileName, version) => {
    StorageService.downloadVersionFilesUrl(
      fileName,
      version,
      this.state.storageId,
      this.state.rootFolder
    )
      .then((response) => {
        if(response !== null && response !== undefined && response.hasOwnProperty("download_url")){
          this.renderText(response.download_url);
          this.setState({ DownloadUrl: response.download_url });
        }
      })
      .catch((error) => {
        this.state.fileType = 'png';
        this.state.myContent = page404;
        this.state.fileName = 'File Not Found!!!';
        this.setState({ loading: false });
      });
  };

  renderText = (url) => {
    this.setState({
      loading: true,
    });
    if (
      this.state.fileType == 'jpeg' ||
      this.state.fileType == 'jpg' ||
      this.state.fileType == 'png'
    ) {
      this.setState({
        myContent: url,
      });
    } else if (this.state.fileType === "csv") {
      axios.get(url).then((response) => {
        if(response.data !== null && response.data.length > 0){
          let result = CSVToJSONs(response.data,this.state.delimiter); 
          this.setState({
            wholeGraphData: result,
            loading: false,
            showNoDataFound: (result !== null && result.length <= 0)? true : false,
        })  
      }
        else{
        this.setState({
          wholeGraphData: [], // Empty the csv content value
        });
        }
      
    });
    }
  };
  
  splitData = (data) => {
    let upperSplit = data.split('\n');
    // upperSplit.length = upperSplit.length - 1;
    let deepSplit = upperSplit?.map((item) => {
      let itemList = item.split(this.state.delimiter);
      return itemList;
    });
    return deepSplit;
  };

  InitGraphDataPaginate = (header, jsonCsv) => {
    let csvFormat = CsvLoad.convertCsvFormat(jsonCsv); // convert array of json object to csv format
    let csvArray = CsvLoad.CSVParseToArray(csvFormat); // convert csv to array
    this.setWholeGraphData(csvArray);
  };

  setWholeGraphData = (csvArray) => {
    var wholeArray = csvArray; // to swab column to rows
    let getHeaders = csvArray.length > 0 ? csvArray[0] : '';
    var Headers = [];
    if(getHeaders !== ""){
      getHeaders.forEach(function (key) {
        Headers.push({
          label: key,
          value: key,
        });
      });
    }
    this.setState({
      loading: false,
      chartHeader: Headers,
      wholeGraphData: wholeArray,
      showNoDataFound: wholeArray.length <= 0 ? true : false,
    });
  };

  csvLoadData = (page) => {
    this.setState({
      loading: true,
    });
    let csvPath = {
      path: this.props.fileName,
      delimiter: this.state.delimiter,
      storageId: this.state.storageId,
      rootFolder: this.state.rootFolder,
    };
    RunService.csvDataPagination(
      csvPath,
      page,
      this.state.storageId,
      this.state.rootFolder
    )
      .then((response) => {
        try {
          if (response.records.length !== 0) {
            this.setState({
              myContent: [], // Empty the csv content value
            });
            let jsonCsv = [];
            for (let record of response.records) {
              var removeSlash = record.replace(/\\/g, '');
              let obj = JSON.parse(removeSlash);
              jsonCsv.push(obj);
            }
            this.setState(
              {
                myContent: jsonCsv,
                totalPages: response.totalPages,
                totalRecords: response.totalRecords,
                loading: false,
              },
              () => {
                this.InitGraphDataPaginate(response.records[0], jsonCsv);
              }
            );
          } else {
            this.setState({
              myContent: [],
              totalPages: 0,
              totalRecords: 0,
              loading: false,
            });
          }
        } catch (err) {
          this.setState({
            myContent: [],
            totalPages: 0,
            totalRecords: 0,
            loading: false,
          });
        }
      })
      .catch((err) => {
        this.setState({
          errorFile: 'Invalid CSV File',
          myContent: [],
          totalPages: 0,
          totalRecords: 0,
          loading: false,
        });
      });
  };

  handleChangeSelectDelimiter = (event) => {
    this.setState({
      myContent: this.state.myContent,
      delimiter: event.value
    });
    this.renderText(this.state.DownloadUrl)
  }

  OpenStorageView = (name, event, hidevalue) => {
    event.preventDefault();
    localStorage.setItem('filePathStorage', name);
    let currentUrl1 = window.location.href;
    var parts = currentUrl1.split('/');
    let fromwhere = parts[parts.length - 1];
    let currentUrl = '';
    let reg = "";
    if (fromwhere === 'project') {
      currentUrl = currentUrl1.replace('?__o=/project', '');
      reg = '/viewProject/' + this.props.projectId;
    } else {
      currentUrl = currentUrl1.replace('/?__o=/runs', '');
      reg = '/runs';
    }
    let path =
      name.slice(-1) === '/'
        ? '/storage?path=' + name
        : '/storageView?file=' + name + '&hideCodeCells=' + hidevalue +'&version=' + this.props.versionName // check folder or file
    let redirectUrl = currentUrl.replace(reg, path);
    window.open(redirectUrl, '_blank');
  };

  render() {
    return (
      <div className='view-csv-body'>
        <LoadingOverlay
          active={this.state.loading}
          spinner={
            <ScaleLoader
              height={35}
              width={5}
              radius={2}
              margin={2}
              color={'#123abc'}
              loading={this.state.loading}
            />
          }
        >
          {this.state.wholeGraphData ? (
            <>
              {this.state.showNoDataFound === false ? (
                <>
                  <Row>
                    <Col xs={4} className="d-flex align-items-center">
                    <b>Choose File Delimiter</b>
                    </Col>
                    <Col xs={6}>
                    <div className='select-div-wrapper'>
                    <div className='select-div'>
                      <Select
                        name='delimiterName'
                        styles={{
                          menuPortal: (provided) => ({
                            ...provided,
                            zIndex: 9999,
                          }),
                          menu: (provided) => ({ ...provided, zIndex: 9999 }),
                        }}
                        value={delimiteroptions.filter(
                          (item) => item.value === this.state.delimiter
                        )}
                        options={delimiteroptions}
                        onChange={this.handleChangeSelectDelimiter}
                        noValidate
                      />
                    </div>
                    
                  </div>
                    </Col>
                    <Col xs={2} className="d-flex justify-content-end align-items-center">
                    <Tooltip placement='left' title='Expand'>
                    <i className="fas fa-expand-arrows-alt text-primary actionicon fa-lg"
                      onClick={(e) =>
                        this.OpenStorageView(this.props.fileName, e, true)
                      }
                      ></i>
                    </Tooltip>
                    </Col>
                  </Row>
                  <HotTable
                    licenseKey={HandsonTableKey}
                    data={this.state.wholeGraphData}
                    colHeaders={true}
                    rowHeaders={true}
                    comments={true}
                    search={true}
                    dropdownMenu={true}
                    settings={this.hotformula}
                    multiColumnSorting={true}
                    filters={true}
                    manualRowMove={true}
                    stretchH='all'
                    width='100%'
                    minHeight='300px'
                  />
                </>
              ) : (
                <Typography className='no-data-found'>No Data Found</Typography>
              )}
            </>
          ) : null}
        </LoadingOverlay>
      </div>
    );
  }
}

export default ViewCsv;
